var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditInfo.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditInfo.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditPrivate.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditPrivate.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditPassword.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditPassword.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditPasswordForgot.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditPasswordForgot.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditBio.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditBio.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditDomicile.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditDomicile.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditSkills.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditSkills.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditExperience.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditExperience.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditRecognition.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditRecognition.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditLocation.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditLocation.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditCredits.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditCredits.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditCreditsAdd.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditCreditsAdd.jinja" );
dependencies["front/components/MemberProfileEdit/MemberProfileEditPortfolio.jinja"] = require( "front/components/MemberProfileEdit/MemberProfileEditPortfolio.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditInfo.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MemberProfileEditInfo")) {
var t_7 = t_4.MemberProfileEditInfo;
} else {
cb(new Error("cannot import 'MemberProfileEditInfo'")); return;
}
context.setVariable("MemberProfileEditInfo", t_7);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditPrivate.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "MemberProfileEditPrivate")) {
var t_11 = t_8.MemberProfileEditPrivate;
} else {
cb(new Error("cannot import 'MemberProfileEditPrivate'")); return;
}
context.setVariable("MemberProfileEditPrivate", t_11);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditPassword.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
t_12.getExported(function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
if(Object.prototype.hasOwnProperty.call(t_12, "MemberProfileEditPassword")) {
var t_15 = t_12.MemberProfileEditPassword;
} else {
cb(new Error("cannot import 'MemberProfileEditPassword'")); return;
}
context.setVariable("MemberProfileEditPassword", t_15);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditPasswordForgot.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_17,t_16) {
if(t_17) { cb(t_17); return; }
t_16.getExported(function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
if(Object.prototype.hasOwnProperty.call(t_16, "MemberProfileEditPasswordForgot")) {
var t_19 = t_16.MemberProfileEditPasswordForgot;
} else {
cb(new Error("cannot import 'MemberProfileEditPasswordForgot'")); return;
}
context.setVariable("MemberProfileEditPasswordForgot", t_19);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditBio.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_21,t_20) {
if(t_21) { cb(t_21); return; }
t_20.getExported(function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
if(Object.prototype.hasOwnProperty.call(t_20, "MemberProfileEditBio")) {
var t_23 = t_20.MemberProfileEditBio;
} else {
cb(new Error("cannot import 'MemberProfileEditBio'")); return;
}
context.setVariable("MemberProfileEditBio", t_23);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditDomicile.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_25,t_24) {
if(t_25) { cb(t_25); return; }
t_24.getExported(function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
if(Object.prototype.hasOwnProperty.call(t_24, "MemberProfileEditDomicile")) {
var t_27 = t_24.MemberProfileEditDomicile;
} else {
cb(new Error("cannot import 'MemberProfileEditDomicile'")); return;
}
context.setVariable("MemberProfileEditDomicile", t_27);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditSkills.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_29,t_28) {
if(t_29) { cb(t_29); return; }
t_28.getExported(function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
if(Object.prototype.hasOwnProperty.call(t_28, "MemberProfileEditSkills")) {
var t_31 = t_28.MemberProfileEditSkills;
} else {
cb(new Error("cannot import 'MemberProfileEditSkills'")); return;
}
context.setVariable("MemberProfileEditSkills", t_31);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditExperience.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_33,t_32) {
if(t_33) { cb(t_33); return; }
t_32.getExported(function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
if(Object.prototype.hasOwnProperty.call(t_32, "MemberProfileEditExperience")) {
var t_35 = t_32.MemberProfileEditExperience;
} else {
cb(new Error("cannot import 'MemberProfileEditExperience'")); return;
}
context.setVariable("MemberProfileEditExperience", t_35);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditRecognition.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_37,t_36) {
if(t_37) { cb(t_37); return; }
t_36.getExported(function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
if(Object.prototype.hasOwnProperty.call(t_36, "MemberProfileEditRecognition")) {
var t_39 = t_36.MemberProfileEditRecognition;
} else {
cb(new Error("cannot import 'MemberProfileEditRecognition'")); return;
}
context.setVariable("MemberProfileEditRecognition", t_39);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditLocation.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_41,t_40) {
if(t_41) { cb(t_41); return; }
t_40.getExported(function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
if(Object.prototype.hasOwnProperty.call(t_40, "MemberProfileEditLocation")) {
var t_43 = t_40.MemberProfileEditLocation;
} else {
cb(new Error("cannot import 'MemberProfileEditLocation'")); return;
}
context.setVariable("MemberProfileEditLocation", t_43);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditCredits.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_45,t_44) {
if(t_45) { cb(t_45); return; }
t_44.getExported(function(t_46,t_44) {
if(t_46) { cb(t_46); return; }
if(Object.prototype.hasOwnProperty.call(t_44, "MemberProfileEditCredits")) {
var t_47 = t_44.MemberProfileEditCredits;
} else {
cb(new Error("cannot import 'MemberProfileEditCredits'")); return;
}
context.setVariable("MemberProfileEditCredits", t_47);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditCreditsAdd.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_49,t_48) {
if(t_49) { cb(t_49); return; }
t_48.getExported(function(t_50,t_48) {
if(t_50) { cb(t_50); return; }
if(Object.prototype.hasOwnProperty.call(t_48, "MemberProfileEditCreditsAdd")) {
var t_51 = t_48.MemberProfileEditCreditsAdd;
} else {
cb(new Error("cannot import 'MemberProfileEditCreditsAdd'")); return;
}
context.setVariable("MemberProfileEditCreditsAdd", t_51);
output += "\n";
env.getTemplate("front/components/MemberProfileEdit/MemberProfileEditPortfolio.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja", false, function(t_53,t_52) {
if(t_53) { cb(t_53); return; }
t_52.getExported(function(t_54,t_52) {
if(t_54) { cb(t_54); return; }
if(Object.prototype.hasOwnProperty.call(t_52, "MemberProfileEditPortfolio")) {
var t_55 = t_52.MemberProfileEditPortfolio;
} else {
cb(new Error("cannot import 'MemberProfileEditPortfolio'")); return;
}
context.setVariable("MemberProfileEditPortfolio", t_55);
output += "\n\n";
var macro_t_56 = runtime.makeMacro(
[], 
["data", "dictionaries", "component", "visibility", "item"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("dictionaries", Object.prototype.hasOwnProperty.call(kwargs, "dictionaries") ? kwargs["dictionaries"] : {});frame.set("component", Object.prototype.hasOwnProperty.call(kwargs, "component") ? kwargs["component"] : "");frame.set("visibility", Object.prototype.hasOwnProperty.call(kwargs, "visibility") ? kwargs["visibility"] : "");frame.set("item", Object.prototype.hasOwnProperty.call(kwargs, "item") ? kwargs["item"] : {});var t_57 = "";t_57 += "\n    <div class=\"MemberProfileEdit MemberProfileEdit-";
t_57 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "component"), env.opts.autoescape);
t_57 += " hidden\" data-component=\"";
t_57 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "component"), env.opts.autoescape);
t_57 += "\">\n        <div class=\"MemberProfileEdit-bg\"></div>\n        <div class=\"MemberProfileEdit-popup\">\n            ";
if(runtime.contextOrFrameLookup(context, frame, "component") == "info") {
t_57 += "\n                 ";
t_57 += runtime.suppressValue((lineno = 21, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditInfo"), "MemberProfileEditInfo", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"dictionaries": runtime.contextOrFrameLookup(context, frame, "dictionaries")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "settings") {
t_57 += "\n                 ";
t_57 += runtime.suppressValue((lineno = 23, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditPrivate"), "MemberProfileEditPrivate", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"visibility": runtime.contextOrFrameLookup(context, frame, "visibility")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "password") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 25, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditPassword"), "MemberProfileEditPassword", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "passwordForgot") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 27, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditPasswordForgot"), "MemberProfileEditPasswordForgot", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "bio") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 29, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditBio"), "MemberProfileEditBio", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "domicile") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 31, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditDomicile"), "MemberProfileEditDomicile", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"dictionaries": runtime.contextOrFrameLookup(context, frame, "dictionaries")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "skills") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 33, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditSkills"), "MemberProfileEditSkills", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"dictionaries": runtime.contextOrFrameLookup(context, frame, "dictionaries")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "experience") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 35, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditExperience"), "MemberProfileEditExperience", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "recognition") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 37, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditRecognition"), "MemberProfileEditRecognition", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "location") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 39, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditLocation"), "MemberProfileEditLocation", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"dictionaries": runtime.contextOrFrameLookup(context, frame, "dictionaries")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "credits") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 41, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditCredits"), "MemberProfileEditCredits", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "creditsAdd") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 43, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditCreditsAdd"), "MemberProfileEditCreditsAdd", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "creditsEdit") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 45, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditCreditsAdd"), "MemberProfileEditCreditsAdd", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"item": runtime.contextOrFrameLookup(context, frame, "item")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "component") == "portfolio") {
t_57 += "\n                ";
t_57 += runtime.suppressValue((lineno = 47, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileEditPortfolio"), "MemberProfileEditPortfolio", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_57 += "\n            ";
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
}
t_57 += "\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_57);
});
context.addExport("MemberProfileEdit");
context.setVariable("MemberProfileEdit", macro_t_56);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})})})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEdit.jinja
// module id = 110
// module chunks = 0